<p
  class="text-center"
  [style.fontFamily]="'var(--disclaimer-font-family)'"
  [style.fontSize]="'var(--disclaimer-font-size)'"
  [style.fontWeight]="'var(--disclaimer-font-weight)'"
  [style.color]="'var(--disclaimer-color)'"
>
  {{ config().text }}
  @if (config().action) {
    <a
      (click)="onLinkClick($event)"
      [style.color]="'var(--disclaimer-link-color)'"
      class="underline cursor-pointer"
    >
      {{ config().linkText }}
    </a>
  } @else {
    <a
      [href]="config().linkUrl"
      [style.color]="'var(--disclaimer-link-color)'"
      class="underline"
    >
      {{ config().linkText }}
    </a>
  }
</p>
